
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-dfd74780&scoped=true!postcss!sass!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Classic.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Classic.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-dfd74780!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Classic.vue"),
  /* scopeId */
  "data-v-dfd74780",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/popularize/Classic.vue
// module id = 1104
// module chunks = 0